import Api from "../api";
// Interfaces and Definitions
export let WorkflowStatus = /*#__PURE__*/ function (WorkflowStatus) {
    WorkflowStatus[WorkflowStatus["Idle"] = 0] = "Idle";
    WorkflowStatus[WorkflowStatus["Executing"] = 1] = "Executing";
    WorkflowStatus[WorkflowStatus["Finished"] = 2] = "Finished";
    WorkflowStatus[WorkflowStatus["Faulted"] = 3] = "Faulted";
    WorkflowStatus[WorkflowStatus["Aborted"] = 4] = "Aborted";
    return WorkflowStatus;
}({});
export let PropertiesType = /*#__PURE__*/ function (PropertiesType) {
    PropertiesType["text"] = "text";
    PropertiesType["list"] = "list";
    PropertiesType["select"] = "select";
    PropertiesType["expression"] = "expression";
    PropertiesType["boolean"] = "boolean";
    PropertiesType["variable"] = "variable";
    PropertiesType["variablePicker"] = "variablePicker";
    return PropertiesType;
}({});
export let ActivityType = /*#__PURE__*/ function (ActivityType) {
    ActivityType["start"] = "Start";
    ActivityType["finish"] = "Finish";
    return ActivityType;
}({});
// Endpoins
const basePathDefinition = "/workflow-definition";
const basePathInstance = "/workflow-instance";
const basePathMonitor = "/workflow-monitor";
function DefinitionGetAll(request) {
    return Api.post(`${basePathDefinition}/v2`, request);
}
function DefinitionGetNames() {
    return Api.get(`${basePathDefinition}/names`);
}
function DefinitionNew() {
    return Api.get(`${basePathDefinition}/create`);
}
function DefinitionCreate(model) {
    return Api.post(`${basePathDefinition}/create`, model);
}
function DefinitionEdit(id) {
    return Api.get(`${basePathDefinition}/edit/${id}`);
}
function DefinitionSaveEdit(id, model) {
    return Api.post(`${basePathDefinition}/edit/${id}`, model);
}
function DefinitionDisable(id, disable) {
    return Api.post(`${basePathDefinition}/disable/${id}/${disable}`);
}
function DefinitionDelete(id) {
    return Api.delete(`${basePathDefinition}/delete/${id}`);
}
function DefinitionDuplicate(id) {
    return Api.get(`${basePathDefinition}/duplicate/${id}`);
}
function DefinitionPublish(id) {
    return Api.post(`${basePathDefinition}/publish/${id}`);
}
function InstanceGetAll(request) {
    return Api.post(`${basePathInstance}/getAll`, request);
}
function InstanceDetails(id) {
    return Api.get(`${basePathInstance}/details/${id}`);
}
function InstanceResume(id) {
    return Api.get(`${basePathInstance}/resume/${id}`);
}
function InstanceDelete(id) {
    return Api.delete(`${basePathInstance}/delete/${id}`);
}
function InstanceFinish(id) {
    return Api.get(`${basePathInstance}/finish/${id}`);
}
function InstanceTrigger(correlationId) {
    return Api.get(`${basePathInstance}/trigger/${correlationId}`);
}
function MonitorStatus() {
    return Api.get(`${basePathMonitor}/status`);
}
function MonitorLogs(request) {
    return Api.post(`${basePathMonitor}/logs`, request);
}
function PdfReport(correlationId) {
    return Api.get(`${basePathInstance}/PdfReport/${correlationId}?listAll=true`, {
        responseType: 'blob'
    });
}
function PdfReportByTask(taskId, timeZoneId) {
    const query = timeZoneId ? `?timeZoneId=${encodeURIComponent(timeZoneId)}` : '';
    return Api.get(`${basePathInstance}/PdfReportByTask/${taskId}${query}`, {
        responseType: 'blob'
    });
}
export { DefinitionCreate, DefinitionDelete, DefinitionDisable, DefinitionDuplicate, DefinitionEdit, DefinitionGetAll, DefinitionGetNames, DefinitionNew, DefinitionPublish, DefinitionSaveEdit, InstanceDelete, InstanceDetails, InstanceFinish, InstanceGetAll, InstanceResume, InstanceTrigger, MonitorLogs, MonitorStatus, PdfReport, PdfReportByTask };
